import { useEffect, useRef, useState } from "react";
import { useSettings } from "@/context/SettingsContext";
import { BadgeCheck } from "lucide-react";

function formatCount(n) {
  if (n >= 1000000) return (n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1) + "M";
  if (n >= 1000) return (n / 1000).toFixed(n % 1000 === 0 ? 0 : 1) + "K";
  return String(n);
}

function CountUp({ target }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !started.current) {
        started.current = true;
        const dur = 2000, start = performance.now();
        const tick = (now) => {
          const p = Math.min((now - start) / dur, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          setVal(Math.floor(eased * target));
          if (p < 1) requestAnimationFrame(tick);
          else setVal(target);
        };
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [target]);
  return <span ref={ref}>{formatCount(val)}</span>;
}

export function InstagramCard() {
  const { settings } = useSettings();
  if (!settings) return null;
  const stats = [
    { label: "gönderi", value: settings.ig_posts || 0, count: false },
    { label: "takipçi", value: settings.ig_followers || 0, count: true },
    { label: "takip", value: settings.ig_following || 0, count: false },
  ];
  return (
    <div className="card-surface card-hover p-6 sm:p-8 max-w-lg mx-auto" data-testid="instagram-card">
      <div className="flex items-center gap-5">
        <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full p-[3px] bg-gradient-to-tr from-[#d8b4fe] via-pink-500 to-yellow-400 shrink-0">
          <div className="w-full h-full rounded-full bg-[#171922] flex items-center justify-center overflow-hidden">
            <img src={settings.ig_profile_image || "/favicon.png"} alt="profil" className="w-full h-full object-contain p-2" />
          </div>
        </div>
        <div>
          <div className="flex items-center gap-1.5">
            <h3 className="text-xl font-bold text-white">{settings.instagram_display_name || "takipcisatis"}</h3>
            <BadgeCheck size={20} className="text-[#3897f0] fill-[#3897f0]/20" />
          </div>
          <p className="text-gray-400 text-sm">@{settings.instagram_username || "takipcisatis"}</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 mt-6">
        {stats.map((s) => (
          <div key={s.label} className="card-surface py-4 text-center">
            <div className="text-2xl font-extrabold text-white">
              {s.count ? <CountUp target={s.value} /> : formatCount(s.value)}
            </div>
            <div className="text-xs text-gray-400 mt-1">{s.label}</div>
          </div>
        ))}
      </div>
      <a href={settings.instagram_url || "#"} target="_blank" rel="noreferrer"
        className="block w-full text-center bg-white text-[#1f222d] font-bold py-3 rounded-xl mt-5 hover:scale-[1.02] transition-transform"
        data-testid="instagram-visit-btn">
        Profili Ziyaret Et
      </a>
    </div>
  );
}
